import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../../ls2pac/ApplicationData";
import { AvailabilityClientManager } from "../../ls2pac/ClientManagers/AvailabilityClientManager";
import { ResourceUtils } from "../../ls2pac/utils/resourceUtils";
import { BaseView } from "../../ls2pac/views/BaseView";
import { LibraryThing } from "../../ls2pac/widget/LibraryThingWidget";
import { KidsAddCoverArt } from "../addCoverArt";
import { LS2KIDS_CONSTANTS } from "../constants";
import { JSIScroll } from "../controls/JSIScroll";
import { KidsHistoryManager } from "../managers/HistoryManager";
import { KidsSearchDatabaseManager } from "../managers/SearchDatabaseManager";
import { KidsCategoryManager } from "../managers/categoryManager";
import { KidsSeriesManager } from "../managers/seriesManager";
import { KidsMessaging } from "../messaging";
import { KidsUtil } from "../utils";
import { seriesLogo } from "../SeriesLogo";
import { AccountHolder } from "@tlc/ls2pac/components/Account";

/**
 * The results view
 * tlc.ls2kids.views.ResultsView
 */
export class KidsResultsView extends BaseView {
	constructor() {

		super({
			id: LS2PAC_CONSTANTS.Ids.SearchPage.searchPageView,
			baseTemplate: 'tmpl/kids/results/resultsView.html',
			targetId: LS2KIDS_CONSTANTS.Ids.mainContent,
			searchEvent: LS2PAC_CONSTANTS.Events.onSearch,
			viewClass: 'baseView'
		});

		this.minPageLength = 1;
		this.maxPageLength = 50;
		this.JACKET_MARGIN = 20;
		this.JACKET_PADDING = 10;
		this.pagerWidth = 30;

		this.VISUAL_DEBUG_TEST = false;

		if (!window.Modernizr.touch) {
			this.pagerWidth = 40;
		}

		this.RESIZE_EVENT_TRIGGERED = false;

		this.addListeners();
	}
	/**
	 * @override
	 * @param {Object} event
	 */
	// TODO: tlc.model.Event
	show(event) {
		super.show(event);

		this.recalculatePageSize();

		var currentSearch = null;

		if (event.searchString != undefined) {
			this.friendlySearchTerm = currentSearch = event.searchString;
		} else if (event.id) {
			currentSearch = "Category-" + event.id;
			var category = KidsCategoryManager.getCategory(event.id);

			if (category) {
				this.friendlySearchTerm = category.name;
			}
		} else if (event.seriesId) {
			currentSearch = "Series-" + event.seriesId;
			var series = KidsSeriesManager.getSeries(event.seriesId);

			if (series) {
				this.friendlySearchTerm = series.name;
			}
		} else {
			TLCLogger.warn("Unknown search type.");
		}

		if (this.currentSearchTerm == currentSearch) {
			return;
		}

		this.currentSearchTerm = currentSearch;

		this._totalResults = 0;
		this._currentPage = 0;
		this._allResources = {};
		this._resetAvailabilityOnPageChanged = false;

		this.disabledArrowState();
		this.updateCurrentSearchIcon(event);

		if (this._resultsEle != null) {
			this._resultsEle.empty();
		}

		this._allImgContainerEle = $();
		this._allJacketsEle = $();

		KidsMessaging.hide();

		if (this._loadingMessageTimeout) {
			clearTimeout(this._loadingMessageTimeout);
		}

		KidsMessaging.showDelayed(ApplicationData.language.loading, 500, function () {
			TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onShowLoadingMessage);
		});
	}
	/**
	 * Load callback from BaseView.
	 * @param event
	 */
	load() {
		this.reFocus();
	}
	updateCurrentSearchIcon(event) {

		TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onHideCurrentSearchIcon);

		var imageUrl = null;

		if (event.id) {
			imageUrl = LS2KIDS_CONSTANTS.restUrls.category.onImage(event.id);
		} else if (event.seriesId) {
			var series = KidsSeriesManager.getSeriesById(event.seriesId);

			if (series) {
				if (series.logos && series.logos.length > 0) {
					imageUrl = seriesLogo(series.logos[0], 100, 100);
				} else {
					imageUrl = LibraryThing.getSeriesLogo(
						LibraryThing.enums.requestType.bookJacketLarge,
						[{ "type": series.contentImageIdentifierType, "data": series.contentImageIdentifier }],
						series.name
					);
				}
			} else {
				TLCLogger.warn("Series ID '" + event.seriesId + "' was not found.");
			}
		}

		if (imageUrl != null) {
			TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onShowCurrentSearchIcon, {
				imageUrl: imageUrl
			});
		}
	}
	/**
	 * Set some stuff after the template was rendered.
	 */
	baseTemplateRenderCallback() {
		this.$view.css({
			'left': this.pagerWidth,
			'right': this.pagerWidth,
			'height': 'auto'
		});


		this._resultsScrollWrapperEle = $("#" + LS2KIDS_CONSTANTS.Ids.SearchPage.resultsScrollWrapper);
		this._searchResultTitleEle = $("#" + LS2KIDS_CONSTANTS.Ids.SearchPage.searchResultTitle);
		this._resultsEle = $("#" + LS2KIDS_CONSTANTS.Ids.SearchPage.resultsList);

		this._prevButton = this.$view.find('.prev');
		this._nextButton = this.$view.find('.next');

		this._createIScroll();
		this.attachEventListeners();
	}
	/**
	 * Callback function for when IScroll has finished scrolling.
	 */
	scrollEnd() {
		// if we're on the same page and it wasn't triggered via a resize event
		if (this._currentPage == this._IScroll.currentPage.pageX && !this.RESIZE_EVENT_TRIGGERED) {
			return;
		}

		this._currentPage = this._IScroll.currentPage.pageX;

		this.createJacketContainers();
		this.disabledArrowState();

		var response = this.fetchPage(this._currentPage);

		if (!response) {
			response = this.fetchNextPage();
		}

		if (!response) {
			response = this.fetchPreviousPage();
		}

		if (this._resetAvailabilityOnPageChanged) {
			this.renderAvailability(this._allResources[this._currentPage + 1].resources, this._currentPage);
		}
	}
	/**
	 * Enable or disable the arrow depending on the current page.
	 */
	disabledArrowState() {
		//	if( !window.Modernizr.touch ) {
		if (this._currentPage == 0) {
			this._prevButton.addClass('disabled');
		} else {
			this._prevButton.removeClass('disabled');
		}

		if (this._currentPage == this._totalPages - 1) {
			this._nextButton.addClass('disabled');
		} else {
			this._nextButton.removeClass('disabled');
		}
		//	}
	}
	createJacketContainers() {
		if (!this.isActive) {
			return;
		}

		var _this = this;

		var currentX = Math.abs(this._IScroll.currentPage.x);

		var childrenCount = this._resultsEle.children().length, totalWidth = (this.jacketSizeInfo.width + this.JACKET_MARGIN) * childrenCount, currentAndBufferAndExtra = currentX + (this.$view.width() * 2);

		if (currentAndBufferAndExtra > totalWidth) {
			var bookCount = Math.ceil((currentAndBufferAndExtra - totalWidth) / (this.jacketSizeInfo.width + this.JACKET_MARGIN));

			if (childrenCount + bookCount > this._totalResults) {
				bookCount = this._totalResults - childrenCount;
			}

			if (bookCount == 0) {
				return;
			}

			TemplateEngine.fetch(
				this._resultItemTemplate,
				this._resultsEle,
				new Array(bookCount),
				function () {
					var newEles = _this._resultsEle.find(".new");

					newEles
						.removeClass('new')
						.addClass('blank');

					var imgContainerEles = newEles.find(".imgContainer");

					imgContainerEles.css({
						width: _this.jacketSizeInfo.width,
						height: _this.jacketSizeInfo.height
					});

					for (var i = 0, imgLen = imgContainerEles.length; i < imgLen; i += 1) {
						_this._allImgContainerEle.push(imgContainerEles[i]);
					}
				}
			);
		}
	}
	attachEventListeners() {
		var _this = this;

		this.$view.on('click touchend', '.next', function (e) {
			e.preventDefault();

			if (!_this._IScroll.isInTransition) {
				_this.nextPage();

				TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onResultsViewNextPage, {
					type: 'click'
				});
			}
		});

		this.$view.on('click touchend', '.prev', function (e) {
			e.preventDefault();

			if (!_this._IScroll.isInTransition) {
				_this.prevPage();

				TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onResultsViewPrevPage, {
					type: 'click'
				});
			}
		});

		$("body").on('keydown', function (e) {
			if (!_this.isActive || _this._IScroll.isInTransition) {
				return;
			}

			if (e.target.tagName.toLowerCase() == "input") {
				return;
			}

			if (e.keyCode == 39) {
				/* right arrow key */
				_this.nextPage();

				TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onResultsViewNextPage, {
					type: 'keypress'
				});

			} else if (e.keyCode == 37) {
				/* left arrow key */
				_this.prevPage();

				TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onResultsViewPrevPage, {
					type: 'keypress'
				});

			}
		});

		var resizeTimeout = null;

		$(window).on('orientationchange resize', function () {
			if (!_this.isActive) {
				return;
			}

			if (resizeTimeout != null) {
				clearTimeout(resizeTimeout);
			}

			resizeTimeout = setTimeout(function () {
				_this.RESIZE_EVENT_TRIGGERED = true;
				_this.onResize();
				_this.RESIZE_EVENT_TRIGGERED = false;
			}, 250);
		});
	}
	/**
	 * @override
	 */
	init(event) {
		super.init(event);

		this._totalResultsEle = $('#' + LS2KIDS_CONSTANTS.Ids.SearchPage.totalResults);
		this._searchResultsAreaContainerEle = $('#' + LS2KIDS_CONSTANTS.Ids.SearchPage.searchResultsAreaContainer);
	}
	/**
	 * The hide event only hides the total results that's showing on the footer.
	 */
	hide() {
		super.hide();

		TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onHideCurrentSearchIcon);
		TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onClearSearch);

		this.currentSearchTerm = null;

		if (this._totalResultsEle) {
			this._totalResultsEle.html('');
		}
	}
	/**
	 * The listeners for this view.
	 */
	addListeners() {
		this.setShowEvent(LS2PAC_CONSTANTS.Events.onSearch);

		this.setHideEvent(LS2KIDS_CONSTANTS.Events.onStartCategoryView);
		this.setHideEvent(LS2KIDS_CONSTANTS.Events.onStartSeriesView);

		TLCEvents.on(TLC_CONSTANTS.Events.onPagingModelResponse, this.onPageResponse, this);
		AccountHolder.subscribe(({user, isAuthenticated}) => this.onGetCurrentUserResponse());
		TLCEvents.on(LS2PAC_CONSTANTS.Events.onGetSpellingSuggestionsResponse, this.onGetSpellingSuggestionsResponse, this);
	}
	/**
	 * Recalculate the number of bookjackets that will fit into the view.
	 */
	recalculatePageSize() {
		this._resultsScrollWrapperEle.css({ 'top': 60, 'right': 0, 'left': 0 });

		var viewHeight = this._resultsScrollWrapperEle.height();
		var viewWidth = this._resultsScrollWrapperEle.width();

		var jacketWidth = Math.floor((viewHeight - (this.JACKET_PADDING * 2)) / this.JACKET_WIDTH_TO_HEIGHT_RATIO);

		var totalJackets = Math.ceil(viewWidth / (jacketWidth + this.JACKET_MARGIN));

		var extraBooks = Math.max(0, totalJackets - this.minPageLength);

		this.pageSize = Math.min(extraBooks + this.minPageLength, this.maxPageLength);

		var jacketContainerWidth = viewWidth - (this.JACKET_MARGIN * this.pageSize);

		jacketWidth = Math.floor(jacketContainerWidth / this.pageSize);

		var jacketHeight = jacketWidth * this.JACKET_WIDTH_TO_HEIGHT_RATIO - (this.JACKET_PADDING * 2);

		var extra = viewWidth - ((jacketWidth + this.JACKET_MARGIN) * this.pageSize);

		this.jacketSizeInfo = {
			'width': jacketWidth,
			'height': jacketHeight
		};

		var actualHeight = this.jacketSizeInfo.height + (this.JACKET_PADDING * 2);
		var leftExtra = Math.floor(extra / 2);
		var rightExtra = Math.ceil(extra / 2);
		var topExtra = Math.floor((viewHeight - actualHeight) / 2);

		this._resultsScrollWrapperEle.css({
			'left': leftExtra,
			'right': rightExtra,
			'top': topExtra + 60
		});

		KidsSearchDatabaseManager.setPageSize(this.pageSize);
	}
	/**
	 * Window resize handler, readjust the current index
	 */
	onResize() {
		var startIndex = this._currentPage * this.pageSize;

		this.recalculatePageSize();

		this._totalPages = Math.ceil(this._totalResults / this.pageSize);

		var newPage = Math.floor(startIndex / this.pageSize);

		// resize the scroller width based on the new jacket size info
		this._resultsEle.css({
			width: Math.max(this._totalResults * (this.jacketSizeInfo.width + this.JACKET_MARGIN), this.$view.width()),
			height: this.jacketSizeInfo.height + (this.JACKET_PADDING * 2)
			//		'margin-top': ( this.$view.height() - this.jacketSizeInfo.height ) / 2
		});

		this.disabledArrowState();

		// resize all the jackets
		// TODO: do this only for the previous/next pages
		this._allImgContainerEle.css({
			width: this.jacketSizeInfo.width,
			height: this.jacketSizeInfo.height
		});

		// vertically center the jackets
		this._allJacketsEle.centerVertically(this.jacketSizeInfo);

		// refresh IScroll
		this._IScroll.refresh();

		if (this._IScroll.scrollerWidth > 0) {
			this._IScroll.goToPage(newPage, 0, 0);

			this.scrollEnd();
		}
	}
	/**
	 * A response handler for when search results have been fetched.
	 *
	 * @param {Object} event
	 */
	onPageResponse(event) {
		if (event.success) {
			if (event.data.totalHits == 0) {
				this.onGetSpellingSuggestions();
			} else {
				this.renderResults(event);
			}
		} else {
			this.showError();
		}
	}
	onGetSpellingSuggestions() {
		TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onGetSpellingSuggestions, {
			searchTerm: this.currentSearchTerm
		});
	}
	onGetSpellingSuggestionsResponse(event) {
		var suggestions = event.suggestions;
		this.hideTotalResults();

		if (suggestions.length == 0) {
			this.showNoResults();
			return;
		}

		var message = '<div class="spelling-suggestions">';
		message += ApplicationData.language.kidsNoResultsSpellingSuggestions.replace("%TERM%", "<span>" + this.friendlySearchTerm + "</span>");
		message += '<ul>';

		for (var i = 0, len = suggestions.length; i < len; i += 1) {
			var suggestion = suggestions[i];

			var url = KidsHistoryManager.createUrl(LS2KIDS_CONSTANTS.Urls.search, {
				searchString: suggestion['suggestion']
			});

			if (i % 2 == 0) {
				message += '<li>';
			} else {
				message += '<li class="alt">';
			}

			message += '<a href="/kids#' + url + '">' + suggestion.suggestion + '</a>';
			message += '</li>';
		}

		message += '</ul>';
		message += '</div>';

		KidsMessaging.show(message);
	}
	/**
	 * No results view.
	 */
	showNoResults() {
		var noResultsNoSpellingSuggestions = '<div class="spelling-suggestions">';
		noResultsNoSpellingSuggestions += ApplicationData.language.kidsNoResultsNoSpellingSuggestions.replace("%TERM%", "<span>" + this.friendlySearchTerm + "</span>");
		noResultsNoSpellingSuggestions += '</div>';

		KidsMessaging.show(noResultsNoSpellingSuggestions);

		this.setTotalResults(0);
		this.hideTotalResults();

		this.onResize();
	}
	/**
	 * Show an error.
	 */
	showError() {
		this._searchResultsAreaContainerEle.html('An error occurred.');
		this.setTotalResults(0);
	}
	/**
	 * Show the number of total results.
	 *
	 * @param {number} count the number of results there were
	 */
	setTotalResults(count) {
		this._totalResults = count;

		this._searchResultTitleEle.html(this._totalResults + " " + ApplicationData.language.kidsResultsFor + " " + this.friendlySearchTerm);
		this._searchResultTitleEle.show();
	}
	hideTotalResults() {
		this._searchResultTitleEle.hide();
	}
	/**
	 * Render any results on the view.
	 * @param {Object} event
	 */
	// TODO: tlc.ls2pac.model.SearchResponse
	renderResults(event) {
		var _this = this;

		var results = event.data, startIndex = this.pageSize * (event.data.currentPage - 1);

		if (startIndex == 0 && !this._allResources[1]) {
			this.setTotalResults(results.totalHits);

			this.onResize();

			this._IScroll.goToPage(0, 0, 0);

			this.createJacketContainers();
		}

		KidsMessaging.clearShowDelayedTimeout();
		KidsMessaging.hide();

		this._allResources[event.data.currentPage] = {
			resources: results.resources,
			pageSize: this.pageSize
		};

		var links = $('#' + LS2KIDS_CONSTANTS.Ids.SearchPage.resultsList + " a");

		for (var i = 0, len = results.resources.length; i < len; i += 1) {
			var linkEle = $(links.get(startIndex + i));
			var resource = results.resources[i];

			if (!linkEle.hasClass('blank')) {
				if (this.VISUAL_DEBUG_TEST) {
					linkEle.addClass('skipped-jacket');
				}

				continue;
			}

			var imgContainer = linkEle.find('.imgContainer'), jacketContainer = imgContainer.find('.jacketContainer');

			linkEle
				.attr('href', "/kids#" + LS2KIDS_CONSTANTS.Urls.fullDetails + "?resourceId=" + resource.id)
				.removeClass('blank');

			if (this.VISUAL_DEBUG_TEST) {
				linkEle.addClass('getting-jacket');
			}

			//		jacketContainer.html( startIndex + i );
			(function (jacketContainer, resource, linkEle) {
				KidsAddCoverArt.load(jacketContainer, {
					requestType: LibraryThing.enums.requestType.bookJacketLarge,
					resources: results.resources,
					index: i,
					displayDummyJacket: true,
					callback: function (isRealJacket) {
						//										jacketContainer.attr( 'title', resource.id );
						jacketContainer.centerVertically(_this.jacketSizeInfo);

						if (_this.VISUAL_DEBUG_TEST) {
							if (isRealJacket) {
								linkEle
									.removeClass('getting-jacket')
									.addClass('dummy-jacket-set');
							} else {
								linkEle
									.removeClass('getting-jacket')
									.removeClass('dummy-jacket-set')
									.addClass('rendered-jacket');
							}
						}
					}
				});
			})(jacketContainer, resource, linkEle);

			this._allJacketsEle.push(jacketContainer.get(0));
		}

		this.renderAvailability(results.resources, event.data.currentPage - 1)
			.then(function () {
				_this._gettingResults = false;

				var response = _this.fetchPage(_this._currentPage);

				if (!response) {
					response = _this.fetchNextPage();
				}

				if (!response) {
					_this.fetchPreviousPage();
				}
			});
	}
	renderAvailability(resources, page) {
		var startIndex = this.pageSize * page;
		var links = $('#' + LS2KIDS_CONSTANTS.Ids.SearchPage.resultsList + " a");

		var deferred = $.Deferred();

		AvailabilityClientManager.getItemAvailability(
			resources,

			/**
			 * @function
			 * @param {Object} availabilityResources
			 */
			function (availabilityResources) {

				for (var i = 0, len = availabilityResources.length; i < len; i += 1) {
					var linkEle = $(links.get(startIndex + i));

					if (linkEle.data('availability-init')) {
						continue;
					}

					var icon = KidsUtil.getAvailabilityIcon(
						availabilityResources[i]
					);

					linkEle.append(icon);

					var resource = resources[i];

					KidsUtil.appendFormatIcon(resource, linkEle);
					KidsUtil.appendReadingLevelIcon(resource, linkEle);

					if (resource.holdingForOnShelf != null) {
						var collection = ResourceUtils.getCollection(resource);
						var callNumber = ResourceUtils.getCallNumber(resource);

						linkEle.append('<div class="details"><span class="collection">' + collection + '</span><span class="callNumber">' + callNumber + '</span></div>');
					} else if (resource.noCopies) {
						linkEle.append('<div class="details"><span class="collection">' + ApplicationData.language.kidsNoCopies + '</span></div>');
					} else if (resource.downloadable) {
						linkEle.append('<div class="details"><span class="collection">' + ApplicationData.language.kidsDownloadable + '</span></div>');
					}

					linkEle.data('availability-init', true);
				}

				deferred.resolve();
			},
			false,
			false
		);

		return deferred.promise();
	}
	fetchNextPage() {
		if (this._currentPage + 1 < this._totalPages) {
			return this.fetchPage(this._currentPage + 1);
		}

		return false;
	}
	fetchPreviousPage() {
		if (this._currentPage - 1 >= 0) {
			return this.fetchPage(this._currentPage - 1);
		}

		return false;
	}
	fetchPage(pageNum) {
		pageNum++;

		if (this._gettingResults) {
			TLCLogger.log("we are already running (this is OK to be fired more than once)!");
			return false;
		}

		if (!this._allResources[pageNum] || this.pageSize != this._allResources[pageNum].pageSize) {
			this._gettingResults = true;

			TLCEventManager.fireEvent(TLC_CONSTANTS.Events.onClickSkipToResultPage, {
				pageNum: pageNum
			});

			return true;
		}

		return false;
	}
	/**
	 * Create a new IScroll element, this handles all the carousel related stuff.
	 *
	 * @private
	 */
	_createIScroll() {
		var _this = this;
		if (window.Modernizr.csstransitions) {
			this._IScroll = new window.IScroll("#" + LS2KIDS_CONSTANTS.Ids.SearchPage.resultsScrollWrapper, {
				scrollX: true,
				scrollY: false,

				click: true,
				snap: true,
				snapSpeed: 400,
				snapThreshold: 0.15,

				vScroll: false,
				momentum: false
			});
		} else {
			this._IScroll = new JSIScroll("#" + LS2KIDS_CONSTANTS.Ids.SearchPage.resultsScrollWrapper);
		}

		this._IScroll.on('scrollEnd', function () {
			_this.scrollEnd();
		});
	}
	nextPage() {
		if (this._IScroll.currentPage.pageX + 1 < this._IScroll.pages.length) {
			this._IScroll.next();
		}
	}
	prevPage() {
		if (this._IScroll.currentPage.pageX > 0) {
			this._IScroll.prev();
		}
	}
	onGetCurrentUserResponse(e) {
		if (this.initialized) {
			this._resetAvailabilityOnPageChanged = true;

			this.renderAvailability(this._allResources[this._currentPage + 1].resources, this._currentPage);
			//	console.log( "LOGIN RESPONSE ", e );
		}
	}
}

/**
 * The search results container, our list is inside.
 * @private
 * @type {jQuery}
 */
KidsResultsView.prototype._searchResultsAreaContainerEle = null;


/**
 * All the .jacketContainer elements (reference needed for quicker resize)
 * @private
 * @type {jQuery}
 */
KidsResultsView.prototype._allJacketsEle = null;

/**
 * All the .imgContainer elements (reference needed for quicker resize)
 * @private
 * @type {jQuery}
 */
KidsResultsView.prototype._allImgContainerEle = null;

/**
 * The total search results element in the footer
 * @private
 * @type {jQuery}
 */
KidsResultsView.prototype._totalResultsEle = null;

/**
 * The search results list container
 * @private
 * @type {jQuery}
 */
KidsResultsView.prototype._resultsEle = null;

/**
 * The ratio of how tall and wide the bookjacket is.
 * @private
 * @type {number}
 */
KidsResultsView.prototype.JACKET_WIDTH_TO_HEIGHT_RATIO = 1.5;

/**
 * The IScroll object
 * @private
 * @type {IScroll}
 */
KidsResultsView.prototype._IScroll = null;

/**
 * Timeout for when a user flings, fires before the scroll actually ends.
 * @private
 * @type {number}
 */
KidsResultsView.prototype._flingTimeout = null;


/**
 * The timeout reference for showing the loading message.
 * @private
 * @type {number}
 */
KidsResultsView.prototype._loadingMessageTimeout = null;

/**
 * Path to the result item template
 * @private
 * @type {string}
 */
	// TODO: tlc.ls2pac.model.AvailabilityResource
KidsResultsView.prototype._resultItemTemplate = "tmpl/kids/results/resultItem.html";

































